import { FormValueResponse } from './../../entities/file/FolderResponse';
import { map } from 'rxjs/operators';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { R } from '@core/utils/r';
import { FrontEndAPI } from '@business/api/frontend';

export class PublicFormBloc extends BaseBloc {
  private readonly itemsRepo = new Repository<FormValueResponse>({
    getItemId: item => `${item.id}`,
  });

  readonly items$ = this.itemsRepo.items$.pipe(
    map(items => {
      return R.orderBy(items, ['type', 'name'], ['desc', 'asc']);
    }),
  );

  onReset() {
    this.itemsRepo.reset();
  }

  saveFormValues = (id: string, data: string, type = 'form') => {
    return FrontEndAPI.saveFormValues(id, data, type).pipe(
      this.itemsRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('fill_form'),
      }),
    );
  };
}
